<div class="login-page">
  <aside class="login-brand">
    <div class="login-brand__head">
      <h1 class="login-brand__title">JioLoyalty</h1>
      <p class="login-brand__kicker">Partner and Business Portal</p>
    </div>

    <!-- Media: shimmer / cover image / fallback, centered in remaining space -->
    <div class="login-brand__media" aria-hidden="true">
      <div
        class="login-brand__shimmer"
        [class.login-brand__shimmer--hidden]="coverState !== 'loading'"
      ></div>
      <div
        class="login-brand__fallback"
        [class.login-brand__fallback--visible]="coverState === 'failed'"
      >
        <img
          src="assets/images/login/jio.svg"
          alt=""
          class="login-brand__fallback-logo"
        />
      </div>
      <div
        class="login-brand__cover"
        [class.login-brand__cover--visible]="coverState === 'loaded'"
        [style.backgroundImage]="coverBgStyle || null"
      ></div>
    </div>

    <div class="login-brand__foot">
      <h2 class="login-brand__foot-title">Break-glass admin access</h2>
      <p class="login-brand__foot-text">
        Direct sign-in for service accounts and local testing. Most
        administrators should use single sign-on instead.
      </p>
    </div>
  </aside>

  <!-- Right: sign-in card -->
  <section class="login-panel">
    <div class="login-card">
      <img
        [src]="logoSrc"
        alt="Jio"
        class="login-card__logo"
        [class.login-card__logo--ready]="logoReady"
      />
      <hr class="login-card__logo-rule" />

      <h2 class="login-card__title">Admin Login</h2>
      <p class="login-card__subtitle">
        Service account / break-glass access only.
      </p>

      <form (ngSubmit)="submit()" class="login-form" autocomplete="on">
        <label class="login-form__label" for="login-admin-email">Email</label>
        <input
          id="login-admin-email"
          name="email"
          type="email"
          autocomplete="email"
          class="login-form__input"
          placeholder="test@test.com"
          [(ngModel)]="email"
          [disabled]="isSubmitting"
          required
        />

        <label class="login-form__label" for="login-admin-password"
          >Password</label
        >
        <input
          id="login-admin-password"
          name="password"
          type="password"
          autocomplete="current-password"
          class="login-form__input login-form__input--last"
          placeholder="Enter your password"
          [(ngModel)]="password"
          [disabled]="isSubmitting"
          required
        />

        @if (errorMessage) {
        <p class="login-form__error">{{ errorMessage }}</p>
        }

        <button
          type="submit"
          class="login-form__submit"
          [disabled]="isSubmitting || !email.trim() || !password"
        >
          {{ isSubmitting ? 'Signing in…' : 'Sign in' }}
        </button>
      </form>

      <footer class="login-footer">
        <span>Powered by</span>
        <img
          src="assets/images/sidenav/jioloyalty_logo_black.svg"
          alt="JioLoyalty"
          class="login-footer__logo"
        />
      </footer>
    </div>
  </section>
</div>
